import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { FiAlertCircle } from 'react-icons/fi';

/**
 * ErrorState Component
 *
 * A reusable error display component with an alert icon and error message.
 * Use this to show error states in sections or cards.
 *
 * @param {Object} props
 * @param {string} props.error - The error message to display
 *
 * @example
 * <ErrorState error="Failed to load data" />
 */
const ErrorState = ({ error }) => (
  <Box p={6} borderRadius="xl" bg="red.900" borderWidth="1px" borderColor="red.700">
    <HStack>
      <FiAlertCircle size={20} />
      <Text color="white" fontSize="md">
        {error || 'An error occurred while fetching data'}
      </Text>
    </HStack>
  </Box>
);

export default ErrorState;
